export default {
    name: 'municipalities',
    component: () => import(/* webpackChunkName: "municipalities-layout" */ '@/modules/municipalities/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.municipalities.index',
            component: () => import(/* webpackChunkName: "municipalities-index" */ '@/modules/municipalities/views/Index'),
        },
        {
            path: 'create',
            name: 'dashboard.municipalities.create',
            component: () => import(/* webpackChunkName: "municipalities-create" */ '@/modules/municipalities/views/Create'),
        },
        {
            path: ':id/edit',
            name: 'dashboard.municipalities.edit',
            component: () => import(/* webpackChunkName: "municipalities-edit" */ '@/modules/municipalities/views/Edit'),
        },
    ]
}